class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);

/* ===== MN UX polish (Oct 2026): on phones show the notification as a bottom toast ===== */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');
  function setup() {
    var host = document.querySelector('cart-notification');
    var note = document.getElementById('cart-notification');
    if (!host || !note) return;
    // The header can be hidden/transformed while scrolling; a fixed toast must live on <body>.
    if (mq.matches && host.parentNode !== document.body) document.body.appendChild(host);
    var timer;
    function arm() {
      clearTimeout(timer);
      if (!mq.matches) return;
      timer = setTimeout(function () {
        if (note.classList.contains('active') && typeof host.close === 'function') host.close();
      }, 5000);
    }
    new MutationObserver(function () {
      var open = note.classList.contains('active');
      document.body.classList.toggle('mn-cn-open', open);
      if (open) arm(); else clearTimeout(timer);
    }).observe(note, { attributes: true, attributeFilter: ['class'] });
    note.addEventListener('touchstart', function () { clearTimeout(timer); }, { passive: true });
    note.addEventListener('touchend', arm, { passive: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
})();
